import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingBeefManureAdditive, setFootprintingBeefManureAdditiveAdmin } from "services";

import { footprintingBeefPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_BEEF_MANURE_ADDITIVE } from "consts";

import { FootprintingBeefManureAdditivePayload } from "models";

export const useMutateFootprintingBeefManureAdditive = (
  farmId: string,
  year: number,
  payload: FootprintingBeefManureAdditivePayload,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_BEEF_MANURE_ADDITIVE, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingBeefManureAdditiveAdmin(payload, primaryDataId) : setFootprintingBeefManureAdditive(payload, primaryDataId)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_BEEF_MANURE_ADDITIVE, primaryDataId, isAdmin],
          ...footprintingBeefPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
